import jQuery from 'jquery';
import _ from 'underscore';

function BrowseCtrl($scope, $state, $q, $rootScope, $stateParams, $location, $document, jsSdkUser,
  utilsService, partnerService, metaTagService, tracking, modalService, iframeService, loggerService, jsSdkCity) {
  $scope.cities = [];
  $scope.city = null;
  $scope.partner = (partnerService.partner) ? partnerService.partner : null;
  $scope.showAffix = false;

  $document.bind('scroll', () => {
    const top = jQuery(window).scrollTop();
    const bar = jQuery('.nav-bar');

    if (!bar || !bar.offset()) return;

    const offset = bar.offset().top;

    $scope.$apply(function() {
      $scope.showAffix = (top - offset) > 0;
    });
  });

  $scope.citiesPromise = jsSdkCity.list();
  $scope.citiesPromise
    .then(cities => {
      cities = partnerService.filterCities(cities);

      cities.forEach(city => {
        city.primaryImage = _.find(city.images, image => {
          return image.primary === true;
        }) || city.images[0];
      });

      $scope.cities = _.sortBy(cities, city => {
        return city.name;
      });
    });

  $scope.setCity = function(citySlug, next) {
    $scope.city = _.find($scope.cities, {
      slugName: citySlug
    });

    if (!$scope.city || !$scope.city.id) {
      loggerService.error('Unknown city. Unable to transition to browse: ', citySlug);

      $state.transitionTo('app.browse.city', {
        city: utilsService.defaultCitySlug()
      });

      return;
    }

    $scope.city.primaryImage = _.find($scope.city.images, {
      primary: true
    });

    _setMetaTags();

    iframeService.postMessage({
      eventType: 'routeChange',
      url: $location.absUrl()
    });

    setPreferredCity($scope.city.id);

    if (next) next($scope.city);
  };

  function _setMetaTags() {
    const cityName = ($scope.city && $scope.city.name) ? `${$scope.city.name} ` : '';

    metaTagService.set({
      title: `${cityName}, bottle service, tickets, tables and packages`,
      description: `Browse Events, Venues, VIP tables, bottle service and events in ${cityName}`,
      facebookImage: $scope.featuredImage
    });
  }

  function setPreferredCity(cityId) {
    const user = jsSdkUser.getCurrentUser();

    if (!user ||
      (user.location && user.location.preferred && user.location.preferred.id === cityId)) {
      return $q.resolve();
    }

    return jsSdkUser.updatePreferredCity(cityId, {
      city: cityId
    });
  }
}

BrowseCtrl.$inject = [
  '$scope',
  '$state',
  '$q',
  '$rootScope',
  '$stateParams',
  '$location',
  '$document',
  'jsSdk.user',
  'utilsService',
  'partnerService',
  'metaTagService',
  'trackingService',
  'modalService',
  'iframeService',
  'loggerService',
  'jsSdk.city'
];

export default BrowseCtrl;



// WEBPACK FOOTER //
// ./src/components/browse/browseCtrl.js